import SharePointConfiguration from '../components/SharePointConfiguration';

const QaRecordSharePoint = () => {
  return (
    <SharePointConfiguration
      title="QA Records SharePoint"
      pageTitle="QA Records SharePoint"
      apiUrl="/v0/qa_records/sharepoint_configuration"
      typesKey="qa_record_types"
      redirectPath="/qa_records"
      adminRole="qa_records_admin"
      readRole="qa_records_readonly"
      contentTypeName="QA Record"
      contentTypeNamePlural="QA Records"
      defaultLocationHelpText="All QA records will be uploaded to this location, unless otherwise defined by record type below."
      noTypesMessage="No QA record types defined. (You can define QA record types in CADM)."
    />
  );
};

export default QaRecordSharePoint;
